import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

export default function AuthLoginPage() {
  const { loginWithRedirect, isAuthenticated } = useAuth0()

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect()
    }
  }, [isAuthenticated, loginWithRedirect])

  return null
}


